import React, { useState } from 'react';
import classNames from 'classnames';
import i18next from 'i18next';
import Ad from 'components/Ad';

export const Sponsor = () => {
  const [rendered, setRendered] = useState(false);

  const handler = (enigmaAd, { EVENTS }) => {
    enigmaAd.on(EVENTS.RENDER, (event) => {
      if (!event || event.empty) {
        return;
      }
      setRendered(true);
    });
  };

  // Links to navbar pre-HFS
  // https://github.com/nbcnews/ramen/blob/0acf32d86f30bcb6567728dab0e1e2debdd1483c/src/components/Navbar/index.jsx#L399
  // https://github.com/nbcnews/ramen/blob/0acf32d86f30bcb6567728dab0e1e2debdd1483c/src/components/Navbar/styles.scss#L451

  return (
    <div
      className={classNames(
        'ad-container v-hidden v-visible-l h-100 justify-center items-center dn',
        { df: rendered },
      )}
    >
      <span className="layout-header__sponsor-text db ttu">
        {i18next.t('Sponsored By')}
      </span>
      <Ad
        adClass="dib lh-none"
        handler={handler}
        refreshInterval={0}
        slot="sponsorlogo"
      />
    </div>
  );
};

Sponsor.propTypes = {};

Sponsor.defaultProps = {};
